module.exports = __webpack_public_path__ + "static/img/commentoid_text_logo.1e390be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/commentoid_text_logo.png
// module id = Y3lg
// module chunks = 1